import React from "react";
import {Outlet, useLocation} from "react-router-dom";
import {getAttendanceRouteMode} from "../../utils/attendanceRouteMode";
import {retryableLazy as lazy} from "../../utils/retryableLazy";

// Operational and member attendance links keep their standalone presentation.
export function isStandaloneAttendanceLocation(location) {
  return /^\/(?:platform\/o|admin)\/[^/]+\/attendance$/.test(location.pathname)
    && getAttendanceRouteMode(location.search) !== "admin";
}

// The verified workspace frame (sidebar, mobile navigation, team
// notifications) is only needed on signed-in admin routes, so it is loaded on
// demand instead of being part of the public first-open entry bundle.
const VerifiedAdminLayout = lazy(() =>
  import("./AdminAppShell").then(module => ({default: module.VerifiedAdminLayout})));

export function PersistentAdminLayout() {
  const location = useLocation();
  return isStandaloneAttendanceLocation(location) ? <Outlet /> : <VerifiedAdminLayout />;
}

export default PersistentAdminLayout;
